import config from "../../../config/config"
import axios from "axios"
//import jwtDecode from "jwt-decode"

const USER_STORE_KEY = "snowflake/user"
//const TIMEOUT_SESSION = 60 * 60 * 1000 * 5 // 5 min

export class EncodedStorage {
  constructor(options) {
    this.key = options.key
  }

  encode(str) {
    if (typeof str !== "string") throw new Error("String expected")
    try {
      const escaped = unescape(encodeURIComponent(str))
      return btoa(escaped)
    } catch (e) {
      console.log("Cant encode string")
      console.log(e)
      return str
    }
  }

  decode(str) {
    try {
      const unescaped = decodeURIComponent(escape(str))
      return atob(unescaped)
    } catch (e) {
      console.log("BAD DATA FORMAT !")
      console.log(e)
      return str
    }

  }

  get() {
    const content = localStorage.getItem(this.key)
    return content ? this.decode(content) : null
  }

  set(value) {
    const content = this.encode(value)
    localStorage.setItem(this.key, content)
  }

  destroy() {
    localStorage.removeItem(USER_STORE_KEY)
  }
}

const storage = new EncodedStorage({ key: USER_STORE_KEY })

/**
 * Storing data for basic auth
 */

export function storeSession(user) {
  //const expires = new Date().getTime() + TIMEOUT_SESSION
  const _user = { ...user }
  storage.set(JSON.stringify(_user))
}

export function destroySession() {
  storage.destroy()
}

/**
 * Alternative Auth user
 * using token
 */

//
// const remainingTime = (user) => {
//   const now = new Date().getTime()
//   const end = user.expires * 1000
//   console.log('remaining ', Math.round((end - now) / 1000) + ' secs')
// }


const disconnectTimeout = {timer: null}
export function autoDisconnect({expires, disconnect}) {
  if (!disconnect) return
  const remaining = expires - new Date().getTime()
  if (remaining < 1) disconnect()
  if (disconnectTimeout.timer) clearTimeout(disconnectTimeout.timer)
  disconnectTimeout.timer = setTimeout(() => {
    disconnect()
    console.log('disconnect')
  }, remaining)
}

export function loadSession() {
  const data = storage.get()
  return new Promise((resolve, reject) => {
    if (data) {
      // Previous login found
      const user = JSON.parse(data)
      if (user && (user.expires * 1000) - new Date().getTime() > 0) {
        //remainingTime(user)
        resolve(user)
      } else {
        destroySession()
        reject("session expired")
      }

    } else {
      reject("No session found")
    }
  })
}


/**
 * Direct Auth user
 * using token
 */

export function doLogin(params) {

  const body = {
    "username": params.username,
    "password": params.password
  }
  return axios({
    url: config.login,
    method: "post",
    data: body
  })

}

export function doLogout({ token }) {

  if (!token) return Promise.reject("Missing token")
  return axios({
    url: config.logout,
    method: "get",
    headers: {
      "X-Auth-Token": token
    }
  })

}
